import '/app/brewery-packages/content/content-editor-plugin-title/src/Title.css-raw';
export default {
  "title": "news-4a753f38-title--87Tha"
};